exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3532ced2] .el-dialog__body{height:91vh!important;max-height:91vh}.titleI[data-v-3532ced2]{position:relative}.titleI>p[data-v-3532ced2]{text-align:center}.titleI .edit-save-btn-sty[data-v-3532ced2]{position:absolute;top:3px;right:21px}.titleI .edit-cancel-btn-sty[data-v-3532ced2]{position:absolute;top:3px;right:120px}.office-body[data-v-3532ced2]{display:-webkit-box;display:-ms-flexbox;display:flex}.office-body .r-info[data-v-3532ced2]{padding:10px}.office-body .btn-box[data-v-3532ced2]{margin-top:20px;text-align:center}.office-box[data-v-3532ced2]{width:170vw;height:83vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3532ced2","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/onlyOffice/editorPup.vue
// module id = 4wPM
// module chunks = 0 2 3 6 7 8 12 13 14 17 26 28 32 34 52 65